import React, { useEffect, useState } from "react";
import { Users, Mail, Phone } from "lucide-react";
import api from "../../lib/api";

export default function AdminCustomers() {
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    api.get("/admin/customers").then(({ data }) => setCustomers(data)).catch(() => {});
  }, []);

  return (
    <div>
      <h1 className="font-serif-display text-3xl text-[#1E3A2F] mb-1">Πελάτες</h1>
      <p className="text-[#536D61] mb-6 text-sm">Εγγεγραμμένοι πελάτες ({customers.length})</p>

      {customers.length ? (
        <div className="bg-white border border-[#E5E9E4] rounded-sm overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-[#536D61] border-b border-[#E5E9E4]">
                <th className="py-3 px-4 font-medium">Όνομα</th>
                <th className="py-3 px-4 font-medium">Email</th>
                <th className="py-3 px-4 font-medium">Τηλέφωνο</th>
                <th className="py-3 px-4 font-medium">Εγγραφή</th>
                <th className="py-3 px-4 font-medium text-right">Παραγγελίες</th>
              </tr>
            </thead>
            <tbody>
              {customers.map((c) => (
                <tr key={c.id} className="border-b border-[#F0F2EE] hover:bg-[#F9F8F6]" data-testid={`customer-row-${c.id}`}>
                  <td className="py-3 px-4 font-medium text-[#1E3A2F]">{c.name}</td>
                  <td className="py-3 px-4 text-[#536D61]"><a href={`mailto:${c.email}`} className="hover:underline">{c.email}</a></td>
                  <td className="py-3 px-4 text-[#536D61]">{c.phone || "—"}</td>
                  <td className="py-3 px-4 text-[#536D61]">{c.created_at ? new Date(c.created_at).toLocaleDateString("el-GR") : "—"}</td>
                  <td className="py-3 px-4 text-right">{c.orders}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="bg-white border border-dashed border-[#E5E9E4] rounded-sm py-16 text-center text-[#536D61]">
          <Users className="h-10 w-10 text-[#1E3A2F]/30 mx-auto mb-3" />
          Δεν υπάρχουν εγγεγραμμένοι πελάτες ακόμη.
        </div>
      )}
    </div>
  );
}
